/* eslint-disable no-underscore-dangle */
export default {
  computed: {
    backendValidationErrorsKey() {
      return `errors_component_${this._uid}`
    },

    backendValidationErrors: {
      get() {
        return this.$store.state.errors.errors[this.backendValidationErrorsKey]
      },

      set(errors) {
        this.$store.commit('errors/setErrors', { key: this.backendValidationErrorsKey, errors })
      }
    }
  },

  methods: {
    handleBackendValidationErrors(e) {
      if (!e.response || e.response.status !== 422) {
        return
      }

      this.backendValidationErrors = e.response.data.errors
    },

    hasErrors(field) {
      return this.backendValidationErrors !== undefined
        && this.backendValidationErrors[field]
        && this.backendValidationErrors[field].length > 0
    },

    getErrors(field) {
      if (!this.hasErrors(field)) {
        return []
      }

      return this.backendValidationErrors[field]
    },

    firstError(field) {
      if (!this.hasErrors(field)) {
        return undefined
      }

      return this.getErrors(field)[0]
    },

    clearErrors(field) {
      if (!this.hasErrors(field)) return

      this.$store.commit('errors/clearErrors', { key: this.backendValidationErrorsKey, field })
    },

    resetErrors() {
      this.$store.commit('errors/resetErrors', { key: this.backendValidationErrorsKey })
    }
  }
}
/* eslint-enable no-underscore-dangle */
